import { render } from "./UserSelectInput.vue?vue&type=template&id=98b49c68&scoped=true"
import script from "./UserSelectInput.vue?vue&type=script&lang=js"
export * from "./UserSelectInput.vue?vue&type=script&lang=js"

import "./UserSelectInput.vue?vue&type=style&index=0&id=98b49c68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98b49c68"]])

export default __exports__